import { routes } from '~/shared/constants/routes';
import { createUrlWithSearchParams, getSearchParamsValues } from '~/shared/lib/searchParams';

export const PAYOUT_CASCADE_NEW_ID = 'new';

export const payoutCascadesTabValues = ['cascades', 'groups', 'templates'] as const;

export type PayoutCascadesTab = (typeof payoutCascadesTabValues)[number];

export const isNewPayoutCascadeEntityId = (id?: string) => !id || id === PAYOUT_CASCADE_NEW_ID;

export interface PayoutCascadesUrlFilter {
    name?: string;
}

export const createPayoutCascadesUrl = (tab?: PayoutCascadesTab, filter?: PayoutCascadesUrlFilter) => {
    return createUrlWithSearchParams(
        routes.cascades,
        { tab: tab && tab !== 'cascades' ? tab : undefined, name: filter?.name },
        { tab: 'tab', name: 'name' },
    );
};

interface PayoutCascadesSearchParams {
    tab?: string;
    name?: string;
}

export const getPayoutCascadesSearchParams = (searchParams: URLSearchParams): PayoutCascadesSearchParams => {
    return getSearchParamsValues<PayoutCascadesSearchParams>(searchParams, { tab: 'tab', name: 'name' });
};

export const createPayoutCascadeUrl = (id: string = PAYOUT_CASCADE_NEW_ID) => {
    return routes['payout-cascade'].replace(':cascadeId', encodeURIComponent(id));
};

export const createPayoutCascadeGroupUrl = (id: string = PAYOUT_CASCADE_NEW_ID) => {
    return routes['payout-cascade-group'].replace(':groupId', encodeURIComponent(id));
};

export const createPayoutCascadeTemplateUrl = (id: string = PAYOUT_CASCADE_NEW_ID) => {
    return routes['payout-cascade-template'].replace(':templateId', encodeURIComponent(id));
};
